class LocationForm extends HTMLElement {
  constructor() {
    super();

    const allStores = [
      {
        name: 'Hemline Mobile',
        lat: '30.698207556977955',
        lng: '-88.142052002627',
        zip: '36608'
      },
      {
        name: 'Hemline Birmingham',
        lat: '33.47979607531168',
        lng: '-86.791340428078',
        zip: '35209'
      },
      {
        name: 'Hemline Huntsville',
        lat: '34.6920211448156',
        lng: '-86.57024197216938',
        zip: '35802'
      },
      {
        name: 'Hemline South Walton',
        lat: '30.378989155352123',
        lng: '-86.31460747379822',
        zip: '32550'
      },
      {
        name: 'Hemline Vinings',
        lat: '33.86577792002857',
        lng: '-84.46692761421608',
        zip: '30339'
      },
      {
        name: 'Hemline Alpharetta',
        lat: '34.07502191250409',
        lng: '-84.29349052994141',
        zip: '30009'
      },
      {
        name: 'Hemline Lafayette',
        lat: '30.169230810646688',
        lng: '-92.03566771573514',
        zip: '70508'
      },
      {
        name: 'Hemline Towne Center',
        lat: '30.432706485513407',
        lng: '-91.11138123107396',
        zip: '70809'
      },
      {
        name: 'Hemline Highland Road',
        lat: '30.346681474768726',
        lng: '-91.04342740223979',
        zip: '70810'
      },
      {
        name: 'Hemline Magazine',
        lat: '29.923269551651888',
        lng: '-90.08794350224959',
        zip: '70115'
      },
      {
        name: 'Hemline Metairie',
        lat: '29.987501527413734',
        lng: '-90.1297689445756',
        zip: '70005'
      },
      {
        name: 'Hemline Mandeville',
        lat: '30.388123617872793',
        lng: '-90.07909368689378',
        zip: '70471'
      },
      {
        name: 'Hemline Monroe',
        lat: '32.524729234759654',
        lng: '-92.1144284886959',
        zip: '71201'
      },
      {
        name: 'Hemline French Quarter',
        lat: '29.957210543326475',
        lng: '-90.06444020224885',
        zip: '70130'
      },
      {
        name: 'Hemline Oxford',
        lat: '34.3660374952015',
        lng: '-89.51973860214018',
        zip: '38655'
      },
      {
        name: 'Hemline Ridgeland',
        lat: '32.44410978731568',
        lng: '-90.15179200218915',
        zip: '39157'
      },
      {
        name: 'Hemline San Antonio',
        lat: '29.49607675553003',
        lng: '-98.4789156310956',
        zip: '78209'
      },
      {
        name: 'Hemline Austin',
        lat: '30.264891872751356',
        lng: '-97.74625344456918',
        zip: '78701'
      },
      {
        name: 'Hemline Lubbock',
        lat: '33.51889683511042',
        lng: '-101.90607073099831',
        zip: '79424'
      },
      {
        name: 'Hemline Fort Worth',
        lat: '32.73922926307096',
        lng: '-97.39156743101807',
        zip: '76107'
      },
      {
        name: 'Hemline Dallas',
        lat: '32.851101436095234',
        lng: '-96.81136531567027',
        zip: '75225'
      },
      {
        name: 'Hemline College Station',
        lat: '30.625299754127035',
        lng: '-96.3394174868882',
        zip: '77840'
      },
      {
        name: 'Hemline The Woodlands',
        lat: '30.164190867561157',
        lng: '-95.46425638875282',
        zip: '77380'
      },
      {
        name: 'Hemline CityCentre',
        lat: '29.779584379393956',
        lng: '-95.5603212734166',
        zip: '77024'
      },
      {
        name: 'Hemline River Oaks',
        lat: '29.75262040923956',
        lng: '-95.41032681759856',
        zip: '77019'
      },
      {
        name: 'Hemline Rice Village',
        lat: '29.714987117516465',
        lng: '-95.41725300225444',
        zip: '77005'
      },
      {
        name: 'Hemline Heights',
        lat: '29.79912634039567',
        lng: '-95.41035268690746',
        zip: '77008'
      },
      {
        name: 'Hemline Woodway',
        lat: '29.753964647863246',
        lng: '-95.50045795992598',
        zip: '77057'
      },
      {
        name: 'Hemline Greenhills',
        lat: '36.10345189871124',
        lng: '-86.81810448860251',
        zip: '37215'
      },
      {
        name: 'Hemline Brentwood',
        lat: '36.032394050068845',
        lng: '-86.79068565976826',
        zip: '37027'
      },
      {
        name: 'Hemline Chattanooga',
        lat: '35.075528403335866',
        lng: '-85.30822980212143',
        zip: '37402'
      },
      {
        name: 'Hemline Memphis',
        lat: '35.10309182219063',
        lng: '-89.85746597328445',
        zip: '38119'
      }
    ]

    this.noStores = document.getElementById('noStoresFound');
    this.allStoresList = document.getElementById('allStoresList');
    this.generatedStoresList = document.getElementById('generatedStoresList');
    this.generatedStoresListInner = document.getElementById('generatedStoresListInner');
    this.searchErrors = document.getElementById('searchZipCodeError');
    this.viewAllStores = document.getElementById('viewAllStores');
    
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', async (event) => {
      event.preventDefault();
      this.searchErrors.style.display = 'none';
      let zipCode = document.getElementById('searchZipCode').value;
      console.log('zipCode:', zipCode);
      let response = await fetch('https://maps.googleapis.com/maps/api/geocode/json?components=postal_code:' + zipCode + '|country:US&key=AIzaSyDk7lO9DTU725oJSH_7d0XO7VJkMjK0oFQ');
      let geocode = await response.json();
      console.log('geocode:', geocode);

      if (geocode.results.length == 0) {
        this.searchErrors.style.display = 'block';
        return;
      }
      
      let geocodeLat = geocode.results[0].geometry.location.lat;
      let geocodeLng = geocode.results[0].geometry.location.lng;

      let distances = [];
      for (const store of allStores) {
        let distance = this.distance(geocodeLat, geocodeLng, store.lat, store.lng);
        if (store.zip == zipCode) {
          distance = 0;
        }
        distances.push({ name: store.name, distance: distance });
      }
      distances.sort((a,b) => a.distance - b.distance);
      
      this.generateList(distances);
    });

    this.viewAllStores.addEventListener('click', () => {
      this.showAllStores();
    });

    const storeLinks = document.querySelectorAll('[data-store-link]');
    for (const link of storeLinks) {
      link.addEventListener('click', async (event) => {
        const goTo = link.getAttribute('data-store-link');
        this.showAllStores();
        document.getElementById(goTo).scrollIntoView(true);
      });
    }
  }

  generateList(distances) {
    this.noStores.style.display = 'none';
    this.generatedStoresListInner.innerHTML = '';

    if (distances[0].distance > 100) {
      this.noStores.style.display = 'block';
    }

    this.allStoresList.style.display = 'none';
    this.generatedStoresList.style.display = 'block';
    
    // Append the five closest stores
    for (let i = 0; i < 5; i++) {
      const node = document.querySelector('#allStoresList [data-store-name="' + distances[i].name + '"]');
      const clone = node.cloneNode(true);
      this.generatedStoresListInner.appendChild(clone);
    }
  }

  distance(lat1, lon1, lat2, lon2, unit) {
    var radlat1 = Math.PI * lat1/180
    var radlat2 = Math.PI * lat2/180
    var radlon1 = Math.PI * lon1/180
    var radlon2 = Math.PI * lon2/180
    var theta = lon1-lon2
    var radtheta = Math.PI * theta/180
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    dist = Math.acos(dist)
    dist = dist * 180/Math.PI
    dist = dist * 60 * 1.1515
    if (unit=="K") { dist = dist * 1.609344 }
    if (unit=="N") { dist = dist * 0.8684 }
    return dist
  }

  showAllStores() {
    this.noStores.style.display = 'none';
    this.generatedStoresList.style.display = 'none';
    this.allStoresList.style.display = 'block';
    document.getElementById('findYourHemline').scrollIntoView(true);
  }
}

customElements.define('location-form', LocationForm);